export default {
  clientId: "6f49f6abacdc76b90883",
  clientSecret: "63fbb051b86c3dfbe501f0d153e8c482fdbb528b",
};
